"use strict";

exports.__esModule = true;
exports.NotificationsIconContext = void 0;
var _clone2 = _interopRequireDefault(require("ramda/src/clone"));
var _react = _interopRequireWildcard(require("react"));
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _UI = require("../../../Utils/UI");
var _Utils = require("../../../Utils");
var _Core = require("../../Core");
var _Profile = require("../../Profile");
var _customHooks = require("../../../Utils/customHooks");
var _useMemoWhenDefined = require("../../../Utils/customHooks/useMemoWhenDefined");
var _Env = require("../../Env");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function NotificationsIconController(_ref) {
  var _profile$user, _profile$user3;
  var children = _ref.children;
  var _useContext = (0, _react.useContext)(_Env.EnvContext),
    notificationsInterval = _useContext.notificationsInterval;
  var _useContext2 = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext2.translate;
  var dataAccess = (0, _react.useContext)(_DataAccessorContext.DataAccessorContext);
  var profile = (0, _react.useContext)(_Profile.ProfileContext);
  var _useState = (0, _react.useState)([]),
    notifications = _useState[0],
    setNotifications = _useState[1];
  var userId = (0, _useMemoWhenDefined.useMemoWhenDefined)({
    value: profile == null || (_profile$user = profile.user) == null ? void 0 : _profile$user.id,
    compute: function compute() {
      var _profile$user2;
      return profile == null || (_profile$user2 = profile.user) == null ? void 0 : _profile$user2.id;
    },
    dependencies: [profile == null || (_profile$user3 = profile.user) == null ? void 0 : _profile$user3.id]
  });
  (0, _react.useEffect)(function () {
    if (userId) {
      getNotifications(userId);
    }
  }, [userId]);
  (0, _customHooks.useInterval)({
    interval: notificationsInterval,
    callbackFunction: function callbackFunction() {
      return getNotifications(userId);
    }
  });
  var getNotifications = function getNotifications(userId) {
    if (userId) {
      dataAccess.getNotificationsForUser(userId).then(function (retrivedNotifications) {
        setNotifications(retrivedNotifications.content.map(function (notification) {
          return Object.assign({
            id: notification._id
          }, notification);
        }).sort(function (x, y) {
          return new Date(y.timestamp).getTime() - new Date(x.timestamp).getTime();
        }));
      })["catch"](function () {
        console.error("Could not retrieve notifications for an user");
      });
    }
  };
  var readNotification = function readNotification(index) {
    var newNotifications = (0, _clone2["default"])(notifications);
    var shouldSendRequest = !newNotifications[index].read;
    newNotifications[index].read = true;
    if (shouldSendRequest) {
      dataAccess.readNotification(newNotifications[index].id, {
        userId: userId
      }).then(function () {
        setNotifications(newNotifications);
      })["catch"](function () {
        (0, _UI.showErrorToaster)(translate("NotificationsIconContext.couldNotRead", "Could not mark the notification as read"));
      });
    }
  };
  var readAllNotifications = function readAllNotifications() {
    var notificationIds = notifications.reduce(function (notificationIdsArray, notification) {
      if (!notification.read) {
        notificationIdsArray.push(notification.id);
      }
      return notificationIdsArray;
    }, []);
    var newNotifications = notifications.map(function (notification) {
      notification.read = true;
      return notification;
    });
    dataAccess.markAllNotificationsAsRead({
      notificationIds: notificationIds,
      userId: userId
    }).then(function () {
      setNotifications(newNotifications);
    })["catch"](function () {
      (0, _UI.showErrorToaster)(translate("NotificationsIconContext.couldNotReadAll", "Could not mark all of the notifications as read"));
    });
  };
  return children({
    notifications: notifications,
    setNotifications: setNotifications,
    readNotification: readNotification,
    readAllNotifications: readAllNotifications
  });
}
var NotificationsIconContext = exports.NotificationsIconContext = (0, _Utils.createEnhancedContext)({
  propName: "notificationsIcon",
  defaultController: NotificationsIconController
});